import axios from "../../node_modules/axios/index"

// Interceptor compartido: cuando el backend responde 401, o 200/403 con
// {sesion_expirada:true} en el body (ver ReporteComisionesVendedores en
// User.controller.js), prende la bandera global -- layouts/Admin.js y
// Subsc.js la leen para mostrar la pantalla de "sesion expirada" en vez de
// dejar la pagina a medias sin avisar. NO se dispara con un 403 comun (sin
// esa bandera): eso es "no tenes permiso", no "tu sesion vencio" -- volver a
// loguearse con el mismo usuario no arregla un 403 por perfil.
//
// OJO: el store de Redux se importa DIFERIDO (require adentro de la
// funcion, no import arriba) a proposito. src/index.js importa
// Flasdeticket/index.js ANTES que StoreRedux/store -- y Flasdeticket
// termina cargando este archivo (utils/index.js) por su cadena de imports,
// asi que si este archivo pidiera el store arriba con un import normal,
// se evaluaria antes de que StoreRedux/store termine de armarse, y
// quedaba `undefined` -> tumbaba TODO el bundle (pagina publica Y admin en
// blanco) con "Cannot read properties of undefined (reading 'forEach')" en
// este archivo. Con require() adentro de la funcion, recien se pide el
// modulo cuando de verdad llega un 401 -- momento en el que el store ya
// esta armado hace rato.
function manejarPosibleSesionExpirada(error) {
    const status = error?.response?.status
    const marcaSesionExpirada = error?.response?.data?.sesion_expirada === true
    if (status === 401 || marcaSesionExpirada) {
        const { store } = require("StoreRedux/store")
        const { setSesionExpirada } = require("StoreRedux/Slice/SuscritorSlice")
        store.dispatch(setSesionExpirada(true))
    }
    return Promise.reject(error)
}

export const mikroAxios = axios.create({
    baseURL: "https://api.t-ickets.com/mikroti/",
    headers: {
        'Content-Type': 'application/json',
        'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
    },
    maxBodyLength: Infinity,
})
export const AxioBoleteria = axios.create({
    baseURL: "https://api.t-ickets.com/ms_login/",
    headers: {
        'Content-Type': 'application/json',
        'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
    },
    maxBodyLength: Infinity,
})
export const Axiosmikroserdos = axios.create({
    baseURL: "https://api.t-ickets.com/mikrotiv2/",
    headers: {
        'Content-Type': 'application/json',
        'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
    },
    maxBodyLength: Infinity,
})
export const boleteriaAxios = axios.create({
    baseURL: "https://api.t-ickets.com/mikroti/",
    headers: {
        'Content-Type': 'application/json',
        'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
    },
    maxBodyLength: Infinity,
})

// El axios "de fabrica" (import axios from "axios" en cualquier archivo del
// proyecto usa el mismo singleton) + estas 4 instancias creadas arriba son
// TODOS los caminos por los que sale una llamada al backend en este
// proyecto -- con esto alcanza para cubrir cualquier request, sin tener que
// tocar cada archivo utils/*Query*.js uno por uno.
//
// OJO: se registra instancia por instancia (NO como
// [a,b,c].forEach(...) encadenado) -- ese patron, con el import de axios
// via ruta relativa de la linea 1, hacia que Babel/webpack compilaran el
// array como una expresion con el operador coma (solo queda el ULTIMO
// elemento) en vez de un array real, y `[...].forEach` tiraba
// "Cannot read properties of undefined (reading 'forEach')" en CUALQUIER
// pagina que cargara este archivo -- publica y admin en blanco por igual.
function registrarInterceptorSesion(instancia) {
    instancia.interceptors.response.use((respuesta) => respuesta, manejarPosibleSesionExpirada)
}
registrarInterceptorSesion(axios)
registrarInterceptorSesion(mikroAxios)
registrarInterceptorSesion(AxioBoleteria)
registrarInterceptorSesion(Axiosmikroserdos)
registrarInterceptorSesion(boleteriaAxios)

export const Consultar_codigos = async (param) => {
    try {
        let { data } = await boleteriaAxios.post("Boleteria/codigos", param)
        return data;
    } catch (error) {
        return error
    }
}

export const infoOrden = async (id) => {
    try {
        let { data } = await boleteriaAxios.get("Boleteria/orden/" + id)
        return data
    } catch (error) {
        return null
    }
}

/**Info de varias ordenes de compra en 1 sola consulta (ver
 * InfoOrdenesCompraBulk en flasapi_speed_comnet). Preferir esto sobre pedir
 * infoOrden(id) en un loop/Promise.all: evita N requests en paralelo (lento
 * con historiales grandes) y evita un 404 por cada id de una orden ya
 * eliminada (el navegador loguea esos 404 en consola igual aunque el JS los
 * capture, no se puede suprimir desde el cliente -- con el bulk simplemente
 * no vienen en la respuesta, sin 404 individual).
 * Devuelve un objeto { [id]: {...} }; ids no encontrados no aparecen. */
export const infoOrdenesBulk = async (ids) => {
    try {
        if (!Array.isArray(ids) || ids.length === 0) return {}
        const { data } = await boleteriaAxios.post("Boleteria/ordenes-bulk", { ids })
        return data?.estado && data?.data ? data.data : {}
    } catch (error) {
        return {}
    }
}